import React from "react";
import { useState } from "react";
import CreateIcon from "Assets/CreateIcon";
import { DebounceInput } from "react-debounce-input";
import { useEffect } from "react";
import PlantCard from "Components/PlantCard";
import PlantModal from "Components/PlantModal";
import MultiSelectIcon from "Assets/MultiSelectIcon";
import Modal from "react-modal";

import { usePlantStore } from "Store/PlantStore";
import { useVarietyStore } from "Store/VarietyStore";
import { getPlantDisplayName } from "Helpers/PlantName";
import TrashIcon from "Assets/TrashIcon";
import { ModalStyle } from "Assets/ModalStyle";

const Plants = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [multiSelectMode, setMultiSelectMode] = useState(false);
  const [selectedPlants, setSelectedPlants] = useState<string[]>([]);
  const [showDeletePlantsModal, setShowDeletePlantsModal] = useState(false);
  const fetchPlants = usePlantStore((state) => state.fetchPlants);
  const plants = usePlantStore((state) => state.plants);
  const deletePlantsById = usePlantStore((state) => state.deletePlantsById);
  const openPlantModal = usePlantStore((state) => state.openPlantModal);
  const varieties = useVarietyStore((state) => state.varieties);
  const fetchVarieties = useVarietyStore((state) => state.fetchVarieties);

  useEffect(() => {
    void fetchPlants();
  }, [fetchPlants]);

  useEffect(() => {
    void fetchVarieties();
  }, [fetchVarieties]);

  const filteredPlants = plants.filter((plant) =>
    getPlantDisplayName(plant, varieties)
      .toLowerCase()
      .includes(searchTerm.toLowerCase()),
  );

  return (
    <div>
      <button
        onClick={() => {
          openPlantModal(undefined, true);
        }}
        className="btn p-15 bg-[darkgreen] circle fixed bottom-5 left-5"
      >
        <CreateIcon />
      </button>

      <div className="px-10 justify-between items-center mt-10">
        <div className="flex">
          <h2 className="text-4xl text-center my-0 mx-auto">Plants</h2>

          <div className="flex">
            {multiSelectMode && selectedPlants.length > 0 && (
              <button
                className="w-10 h-10 text-red"
                onClick={() => setShowDeletePlantsModal(true)}
              >
                <TrashIcon />
              </button>
            )}

            <button
              className="w-10 h-10"
              onClick={() => {
                setMultiSelectMode(!multiSelectMode);
                if (!multiSelectMode) {
                  setSelectedPlants([]);
                }
              }}
            >
              <MultiSelectIcon
                stroke={multiSelectMode ? "rgb(28, 151, 246)" : "#000"}
              />
            </button>
          </div>
        </div>
        <DebounceInput
          className="border-solid border rounded border-gray px-10 py-3 w-full md:w-300 my-5"
          placeholder={"Search"}
          minLength={2}
          debounceTimeout={300}
          onChange={(event) => setSearchTerm(event.target.value)}
        />
      </div>

      <div className="flex flex-wrap">
        {filteredPlants.map((plant, i) => {
          return (
            <div key={i}>
              <PlantCard
                key={plant._id}
                plantId={plant._id}
                multiSelectMode={multiSelectMode}
                setSelectedPlants={setSelectedPlants}
                selectedPlants={selectedPlants}
              />
            </div>
          );
        })}
      </div>

      <PlantModal />

      <Modal
        style={ModalStyle.defaultStyle}
        ariaHideApp={false}
        isOpen={showDeletePlantsModal}
      >
        <div className="m-50 p-5 grid grid-cols-1 grid-rows-3 h-full w-full text-center justify-center items-center">
          <h3 className="text-lg py-5">Delete Plants</h3>
          <p>
            Are you sure you want to delete the following{" "}
            {selectedPlants.length} plants?
          </p>
          <div className="flex items-center justify-center">
            {plants
              .reduce((acc: string[], plant) => {
                if (selectedPlants.includes(plant._id)) {
                  acc.push(getPlantDisplayName(plant, varieties));
                }
                return acc;
              }, [])
              .map((name, index) => (
                <p className="p-2" key={index}>
                  {name}
                </p>
              ))}
          </div>
          <div className="flex justify-center items-center">
            <button
              onClick={() => setShowDeletePlantsModal(false)}
              className="btn bg-gray-light mr-5  h-10 w-[150px]"
            >
              Cancel
            </button>
            <button
              className="btn bg-red text-white mr-5 h-10 w-[150px]"
              onClick={() => {
                deletePlantsById(selectedPlants);
                setMultiSelectMode(false);
                setShowDeletePlantsModal(false);
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Plants;
